<template>
  <div id="onB">
    <v-dialog v-model="value" persistent width="85%">
      
      <v-card color="white" style="border-radius: 33px; box-shadow: none;" >
        <v-layout row align-center justify-space-between style="box-shadow: none;">
        <v-flex grow class="ml-5 mt-5" v-if="showHeader">
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>house</v-icon>
          </div>
          <h1 style="display: inline; font-weight: 500;">Bienvenido a skolable</h1>
        </v-flex>
      </v-layout>
        <v-stepper v-model="e1"  style="box-shadow: none;" >
          <v-stepper-header style="box-shadow: none;" v-if="showHeader">
            <v-divider></v-divider>
            <v-stepper-step  :complete="e1 > 1" :step="1">Configuración inicial</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step  :complete="e1 > 2" :step="2">Registro de usuario</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step  :complete="e1 > 3" :step="3">Registro de la institución</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 4" :step="4">Ubicación del instituto</v-stepper-step>
            <v-divider></v-divider>
            <!-- <v-stepper-step v-if="e1 == 5" :complete="e1 > 5" :step="5">Nivel, grado y grupo</v-stepper-step> -->
            <!-- <v-divider></v-divider> -->
            <!-- <v-stepper-step v-if="e1 == 6" :complete="e1 > 6" :step="6">Registro de tutor e hijo</v-stepper-step> -->
            <!-- <v-divider></v-divider> -->
            <v-stepper-step v-if="e1 == 5" :complete="e1 > 5" :step="5">Finalizado</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content :step="1">
              <v-layout row wrap  align-center>
                <v-flex xs12 sm12 md6  class="text-xs-left" style="display:flex; align-items: center;">
                  <div
                    class="mr-3"
                    :style="{
                      padding: '3px 3px 3px 3px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '30px',
                      backgroundColor: '#F6ECFF',
                      borderRadius: '0.5rem',
                    }"
                  >
                    <v-icon color="#512E6F"  style="padding: 0px; margin: 0px" small>speaker_notes</v-icon>
                  </div>
                  <div>
                    <h3 style="color:#6B7280;">
                    Estas muy cerca de comenzar a utilizar skolable, pero antes es necesario que realices tu configuración inicial.
                  </h3>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-flex sm6 class="text-xs-center">
                  <v-img width="441"  class="mx-auto" :src="require('@/assets/onBoarding/SKLB-S1.png')"></v-img>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>

                <v-flex xs12 sm12 class="text-xs-right">
                  <v-btn
                  class="btn__iniciar"
                  style="font-size:14px; border-radius: 5px; background:#f44336;text-transform:inherit; color:#fff"
                  @click="next"
                  depressed
                  >Iniciar</v-btn
                >
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content :step="2">
              <v-layout row wrap justify-center fill-height align-center>
                <v-flex xs12 sm6>
                  <v-layout row wrap>
                    <v-flex xs12 class="text-xs-left" style="display:flex; align-items: center;">
                      <div
                    class="mr-3"
                    :style="{
                      padding: '3px 3px 3px 3px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '30px',
                      backgroundColor: '#F6ECFF',
                      borderRadius: '0.5rem',
                    }"
                  >
                    <v-icon color="#512E6F"  style="padding: 0px; margin: 0px" small>speaker_notes</v-icon>
                  </div>
                      <div>
                        <h3 style="color:#6B7280;" class="text-left">
                    Registrate como un usuario de skolable y disfruta de las funcionalidades que la plataforma te ofrece.
                  </h3>
                      </div>
                      
                    </v-flex>
                    <v-flex xs12>
                      <v-img
                        :src="
                          require('@/assets/onBoarding/SKLB-Artboard 1 copy.png')
                        "
                      ></v-img>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-form>
                    <v-layout row wrap justify-center fill-height align-center>
                      <v-flex xs8>
                        <h4 class="mb-3">DATOS DEL USUARIO</h4>

                        <h4>Nombre</h4>
                        <v-text-field
                          v-model="$v.userForm.firstName.$model"
                          outline
                          height="38px"
                          :error-messages="processErrorName"
                        >
                      </v-text-field>



                      </v-flex>
                      <v-flex xs8>
                        <h4>Apellidos</h4>
                        <v-text-field
                          v-model="$v.userForm.lastName.$model"
                          outline
                          height="38px"

                          :error-messages="processErrorLastName"
                        >
                      
                      </v-text-field>
                      </v-flex>
                      <v-flex xs8>
                        <h4>Correo electrónico</h4>
                        <v-text-field
                          v-model="$v.userForm.mail.$model"
                        
                          outline
                          :error-messages="processErrorEmail"
                          disabled
                          height="38px"

                        ></v-text-field>
                      </v-flex>
                      <v-flex xs8>
                        <v-layout row wrap justify-space-between>
                          <v-flex xs4 sm3>
                            <h4> Lada </h4>
                            <v-select
                              v-model="flagSelection"
                              :items="flags"

                             outline
                             height="38px"
                              item-value="code"
                            >
                              <template slot="selection" slot-scope="data">
                                <v-list-tile-avatar>
                                  <flag :iso="data.item.flag"></flag>
                                </v-list-tile-avatar>
                              </template>
                              <template slot="item" slot-scope="data">
                                <v-list-tile-avatar>
                                  <flag :iso="data.item.flag"></flag>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ data.item.code }}</v-list-tile-title>
                                </v-list-tile-content>
                              </template>
                            </v-select>
                          </v-flex>


                          <v-flex xs8 sm8>
                            <h4>Teléfono</h4>
                            <v-text-field
                              :prefix="flagSelection"
                              v-model="$v.userForm.phone.$model"
                             
                              outline
                              height="38px"
                              mask="(###) ### - ####"
                              :error-messages="processErrorPhone"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 class="text-xs-right">
                        <!-- <v-btn @click="back" round color="transparent">Atrás</v-btn>
                        <v-btn @click="next" dark color="gradiente" round>Continuar</v-btn> -->


                        <v-btn
                          class="btn__next"
                          style="font-size:14px; border-radius: 5px;border: 1px solid #E5E7EB; background:#fff;text-transform:inherit; color:#374151"
                          @click="back"
                          depressed
                          >Anterior</v-btn
                        >

                        <v-btn
                          class="btn__next"
                          style="font-size:14px; border-radius: 5px;border: 1px solid #E5E7EB; background:#fff;text-transform:inherit; color:#374151"
                          @click="next"
                          depressed
                          >Siguiente</v-btn
                        >


                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content :complete="e1 > 3" :step="3">
              <v-form>
                <v-layout row wrap justify-center fill-height align-center>
                  <v-flex xs12 sm6>
                    <v-layout row wrap>
                
                  <v-flex xs12 class="text-xs-left" style="display:flex; align-items: center;">
                      <div
                    class="mr-3"
                    :style="{
                      padding: '3px 3px 3px 3px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '30px',
                      backgroundColor: '#F6ECFF',
                      borderRadius: '0.5rem',
                    }"
                  >
                    <v-icon color="#512E6F"  style="padding: 0px; margin: 0px" small>speaker_notes</v-icon>
                  </div>
                      <div>
                        <h3 style="color:#6B7280;" class="text-left">
                          Ingresa el nombre de tu colegio, recuerda que puedes
                    modificarlos posteriormente.
                  </h3>
                      </div>
                    </v-flex>
                  <v-flex xs12>
                    <v-img :src="require('@/assets/onBoarding/SKLB-Colegio.png')"></v-img>
                  </v-flex>
                  </v-layout>
                </v-flex>
                  <v-flex xs12 sm6>
                    <v-layout row wrap justify-center fill-height align-center>
                      <v-flex xs12 sm7>
                        <h4 class="mb-3">DATOS DE LA INSTITUCIÓN</h4>

                        <h4>Nombre</h4>
                        <v-text-field
                          v-model="$v.branchForm.name.$model"
                          outline
                          height="38px"
                          :error-messages="processBranchName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <h4>Ciudad o país</h4>
                        <v-text-field v-model="city" height="38px" outline></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7 class="text-xs-right">
                        <!-- <v-btn @click="back" round color="transparent">Atrás</v-btn>
                        <v-btn @click="next" dark color="gradiente" round>Continuar</v-btn> -->
                        <v-btn
                          class="btn__next"
                          style="font-size:14px; border-radius: 5px;border: 1px solid #E5E7EB; background:#fff;text-transform:inherit; color:#374151"
                          @click="back"
                          depressed
                          >Anterior</v-btn
                        >

                        <v-btn
                          class="btn__next"
                          style="font-size:14px; border-radius: 5px;border: 1px solid #E5E7EB; background:#fff;text-transform:inherit; color:#374151"
                          @click="next"
                          depressed
                          >Siguiente</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-stepper-content>
            <v-stepper-content style="padding: 0;" :complete="e1 > 4" :step="4">
              <BoardingMap
                v-on:inputBranch="inputBranch"
                v-on:doors="inputDoors"
                v-on:timeZone="inputTimezone"
                v-on:zoom="inputZoom"
                :e1Flag="e1Flag"
                :showText="showText"
                :fSearch="search"
                class="mt-5"
              ></BoardingMap>
              <div  v-show="e1 == 4"  style="width: 100%; height: 90px; background: #fff; position:absolute; bottom: 0%; right: 0%; left: 0%;">
                <v-layout row wrap justify-end fill-height align-center>
                  <v-flex xs12 sm6 md6 v-if="!e1Flag" class="text-xs-left" style="display:flex; align-items: center;">
                  <div
                    class="mr-3 ml-3"
                    :style="{
                      padding: '3px 3px 3px 3px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '30px',
                      backgroundColor: '#F6ECFF',
                      borderRadius: '0.5rem',
                    }"
                  >
                    <v-icon color="#512E6F"  style="padding: 0px; margin: 0px" small>speaker_notes</v-icon>
                  </div>
                  <div>
                    <h4 style="color:#6B7280;">
                      Establece la ubicación exacta de tu colegio
                  </h4>
                  </div>
                </v-flex>
                 
                  <v-flex xs12 sm6 md6 class="text-xs-right">
                  <v-btn
              v-show="e1 == 4" 
                class="btn__next"
                  style="font-size:14px; border-radius: 5px;border: 1px solid #E5E7EB; background:#fff;text-transform:inherit; color:#374151"
                @click="back"
                  depressed
                >Anterior</v-btn
              >
              <v-btn
              v-show="e1 == 4"
                class="btn__next"
              style="font-size:14px; border-radius: 5px;border: 1px solid #E5E7EB; background:#fff;text-transform:inherit; color:#374151"
                @click="next"
              depressed
              >Siguiente</v-btn
              >  
                </v-flex>
                </v-layout>
              </div>
            </v-stepper-content>
            <!-- <v-stepper-content :complete="e1 > 5" :step="5">
              <v-form>
                <v-layout row wrap justify-center fill-height align-center>
                  <v-flex xs12 sm6>
                    <h2 class="text-xs-center title">
                      Cada vez estás más cerca. Ahora registra un nivel escolar,
                      un grado y un grupo para darle forma a esta genialidad.
                    </h2>
                    <v-img :src="require('@/assets/onBoarding/SKLB-Niveles.png')"></v-img>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-layout row wrap justify-center fill-height align-center>
                      <v-flex xs12 sm7>
                        <v-text-field
                          :error-messages="processLevelName"
                          v-model="levelForm.typeLevel"
                          label="Nivel escolar"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-text-field
                          :error-messages="processLevelAbbr"
                          maxlength="3"
                          mask="NNN"
                          counter
                          v-model="levelForm.abbr"
                          label="Abreviación"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-text-field
                          :error-messages="processGGrade"
                          v-model="ggForm.grade"
                          label="Grado"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-text-field
                          :error-messages="processGGroup"
                          v-model="ggForm.group"
                          label="Grupo"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-layout row wrap justify-space-around>
                          <v-flex xs5>
                            <v-menu
                              ref="clock"
                              v-model="modals.clock"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="levelForm.departureTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :error-messages="processLevelDepartureTime"
                                  v-model="levelForm.departureTime"
                                  label="Hora de salida"
                                  placeholder="hh:mm"
                                  prepend-icon="access_time"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="modals.clock"
                                v-model="levelForm.departureTime"
                                full-width
                                format="24hr"
                                @click:minute="
                                  $refs.clock.save(levelForm.departureTime)
                                "
                                color="secondary"
                                header-color="primary"
                                scrollable
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs5>
                            <v-select
                              item-text="doorName"
                              multiple
                              :items="doors"
                              v-model="levelForm.doors"
                              label="Puertas del nivel"
                              :error-messages="processLevelDoors"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm7 class="text-xs-center">
                        <v-btn @click="back" round color="transparent">Atrás</v-btn>
                        <v-btn @click="next" dark color="gradiente" round>Continuar</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-stepper-content> -->
            <!-- <v-stepper-content :complete="e1 > 6" :step="6">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h2 class="text-xs-center title">
                        Genial! Llegaste al último paso. Registra un alumno y
                        otórgale un tutor. Con esto terminas la configuración
                        inicial
                      </h2>
                      <v-img
                        :src="
                          require('@/assets/onBoarding/SKLB-Registro Tutor y Alumno.png')
                        "
                      ></v-img>
                    </v-flex>
                    <v-flex xs12 sm7 class="text-xs-center">
                      <v-btn @click="back" round color="transparent">Atrás</v-btn>
                      <v-btn @click="next" dark color="gradiente" round>Continuar</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-form>
                    <v-layout row wrap justify-center fill-height align-center>
                      <v-flex xs12 sm7>
                        <v-subheader>Datos del alumno</v-subheader>
                        <v-text-field
                          v-model="$v.studentForm.firstName.$model"
                          label="Nombre(s)"
                          outline
                          :error-messages="processStudentfirstName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-text-field
                          v-model="$v.studentForm.lastName.$model"
                          label="Apellidos"
                          outline
                          :error-messages="processStudentlastName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-select
                          outline
                          v-model="$v.studentForm.gender.$model"
                          :error-messages="processStudentGender"
                          item-text="name"
                          item-value="key"
                          :items="genders"
                          label="Género"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-text-field
                          v-model="$v.studentForm.personId.$model"
                          label="Matrícula"
                          outline
                          :error-messages="processStudentPersonId"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-subheader>Datos del tutor</v-subheader>
                        <v-text-field
                          :error-messages="processParentfirstName"
                          v-model="$v.parentForm.firstName.$model"
                          label="Nombre(s)"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-text-field
                          :error-messages="processParentLastName"
                          v-model="$v.parentForm.lastName.$model"
                          label="Apellidos"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-text-field
                          :error-messages="processParentMail"
                          v-model="$v.parentForm.mail.$model"
                          label="Correo"
                          outline
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-stepper-content> -->
            <v-stepper-content :complete="e1 > 5" :step="5">
              <v-layout row wrap justify-center>
                <v-flex class="text-xs-center" xs12 sm6>
                  <v-img width="" :src="require('@/assets/onBoarding/SKLB-Terminado_1.png')"></v-img>

                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-flex class="text-xs-center" xs12 sm12>
                  <h1 class="text-xs-center display-3">Felicitaciones</h1>
                  <h2 class="text-xs-center">Has terminado la configuración inicial</h2>
                  <h3 class="text-xs-center">
                    Recuerda que más adelante puedes agregar cuantos niveles
                    escolares sean necesarios, así como sus grados y sus grupos.
                  </h3>
                  <!-- <v-btn dark color="gradiente" @click="close" round>Comenzar</v-btn> -->
                  <v-btn
                  class="btn__iniciar"
                  style="font-size:14px; border-radius: 5px; background:#f44336;text-transform:inherit; color:#fff"
                  @click="close"
                  depressed
                  >Comenzar</v-btn
                >
                </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
          
        </v-stepper>

        <!-- <v-btn
        
        style="position:absolute; top: 5%; right: 2%"
        color="warning"
        icon="mdi-close"
        @click="logOut"
      ></v-btn> -->
      <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: 'transparent',
              borderRadius: '0.5rem',
              position: 'absolute',
              top: '1%',
              right: '1%'
              
            }"
          >
            <v-icon @click="logOut" color="#6B7280" medium>close</v-icon>
          </div>
      </v-card>
      <!-- <v-btn  
      style="position:absolute; bottom: 22%; left: 14%"  
      v-show="e1 == 4" 
      @click="back" 
      round 
      color="transparent">Atrás</v-btn> -->
      <!-- <div  v-show="e1 == 4"  style="width: 100%; height: 100px; background: #fff; position:absolute; bottom: 22%; right: 0%; left: 0%;">

        <v-btn
      v-show="e1 == 4" 

           class="btn__next"
            style="font-size:14px;position:absolute; bottom: 22%; right: 24%; border-radius: 5px;border: 1px solid #E5E7EB; background:#fff;text-transform:inherit; color:#374151"
           @click="back"
            depressed
          >Anterior</v-btn
         >
      <v-btn
      v-show="e1 == 4"
          class="btn__next"
         style="font-size:14px;position:absolute; bottom: 22%; right: 14%; border-radius: 5px;border: 1px solid #E5E7EB; background:#fff;text-transform:inherit; color:#374151"
          @click="next"
         depressed
        >Siguiente</v-btn
        >

      </div> -->
      <!-- <v-btn
        round
        v-show="e1 == 4"
        dark
        style="position:absolute; bottom: 22%; right: 14%"
        color="gradiente"
        @click="next"
      >Guardar</v-btn> -->
     
    </v-dialog>
    <alert v-model="modals.alert" title="Error" :description="modals.errorDescription"></alert>
    <loading v-model="modals.loading" :text="modals.text"></loading>
  </div>
</template>

<script>
import loading from "../Dialogs/Loading2";
import { mapGetters } from "vuex";
import alert from "../Dialogs/Alert";
import { required, email, minLength } from "vuelidate/lib/validators";
import BoardingMap from "../Sections/Boarding/BoardingMap";
import { setTimeout } from "timers";
export default {
  components: {
    BoardingMap,
    loading,
    alert
  },
  props: ["value"],
  watch: {
    value() {
      if (this.value) {
        this.e1 = 1;
        this.$v.userForm.mail.$model = this.getUser.mail && this.getUser.mail;
      }
    },
    getUser() {
      this.$v.userForm.mail.$model = this.getUser.mail && this.getUser.mail;
    }
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      mail: { required, email },
      phone: { required }
    },
    branchForm: {
      name: { required },
      address: { required },
      timezone: { required },
      markLatitude: { required },
      markLongitude: { required },
      latitude: { required },
      longitude: { required },
      zoom: { required }
    },
    levelForm: {
      typeLevel: { required },
      abbr: { required },
      departureTime: { required },
      doors: { required, minLength: minLength(1) }
    },
    ggForm: {
      grade: { required },
      group: { required }
    },
    studentForm: {
      firstName: { required },
      lastName: { required },
      gender: { required },
      personId: { required }
    },
    parentForm: {
      firstName: { required },
      lastName: { required },
      mail: { required, email }
    }
  },
  data: () => ({
    showText: true,
    showHeader: true,
    e1: 0,
    e1Flag: false,
    userForm: {
      firstName: "",
      lastName: "",
      mail: "",
      phone: ""
    },
    search: "",
    city: "",
    branchForm: {
      name: "",
      address: "",
      timezone: "",
      markLatitude: "",
      markLongitude: "",
      latitude: "",
      longitude: "",
      zoom: ""
    },
    levelForm: {
      typeLevel: "",
      abbr: "",
      departureTime: "",
      doors: []
    },
    ggForm: {
      grade: "",
      group: ""
    },
    studentForm: {
      firstName: "",
      lastName: "",
      gender: "",
      personId: ""
    },
    parentForm: {
      firstName: "",
      lastName: "",
      mail: ""
    },
    genders: [
      {
        key: "MALE",
        name: "Masculino"
      },
      {
        key: "FEMALE",
        name: "Femenino"
      }
    ],
    modals: {
      clock: false,
      loading: false,
      text: "",
      errorDescription: "",
      alert: false
    },
    flags: {
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false,
      step7: false
    },
    flags: [
      {
        code: "+52",
        flag: "mx"
      },
      {
        code: "+1",
        flag: "us"
      }
    ],
    flagSelection: "+52",
    doors: [],
    responses: [],
    errors: []
  }),
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("success");
    },
    back() {
      switch (this.e1) {
        case 2:
          this.e1--;
        this.showHeader = true;
          break;
        case 3:
          this.e1--;
        this.showHeader = true;
          break;
        case 4:
          if (this.e1Flag) {
            this.e1Flag = false;
          } else {
            this.e1--;
        this.showHeader = true;
          }
          break;
        case 4:
          this.e1--;
        this.showHeader = true;
          break;
        case 5:
          this.e1--;
          break;
        case 6:
          this.e1--;
          break;
      }
    },
    next() {
      switch (this.e1) {
        case 1:
        this.showHeader = true;
          this.e1++;
          break;
        case 2:
        this.showHeader = true;
          this.$v.userForm.$touch();
          if (!this.$v.userForm.$invalid) {
            this.e1++;
          }
          break;
        case 3:
          this.$v.branchForm.name.$touch();
          if (!this.$v.branchForm.name.$invalid) {
            this.e1++;
            this.search = this.branchForm.name + " " + this.city;
            this.showHeader = false;

          }
          break;
        case 4:
          this.showHeader = false;
          this.$v.branchForm.markLatitude.$touch();
          this.$v.branchForm.markLongitude.$touch();
          this.$v.branchForm.latitude.$touch();
          this.$v.branchForm.longitude.$touch();
          this.$v.branchForm.address.$touch();
          if (
            !this.$v.branchForm.markLatitude.$invalid &&
            !this.$v.branchForm.markLongitude.$invalid &&
            !this.$v.branchForm.latitude.$invalid &&
            !this.$v.branchForm.longitude.$invalid &&
            !this.$v.branchForm.address.$invalid
          ) {
            if (this.e1Flag) {
              if (this.doors.length > 0) {
                // this.e1++;
                this.modals.loading = true;
                this.modals.text = "Creando institución";
                this.begin();

              } else {
                this.modals.alert = true;
                this.modals.errorDescription =
                  "Debes agregar al menos una puerta";
              }
            } else {
              this.e1Flag = true;
            }
          } else {
          }

          break;
        // case 5:
        //   this.$v.levelForm.$touch();
        //   this.$v.ggForm.$touch();
        //   if (!this.$v.levelForm.$invalid && !this.$v.ggForm.$invalid) {
        //     this.e1++;
        //   }

        //   break;
        // case 6:
        //   this.$v.studentForm.$touch();
        //   this.$v.parentForm.$touch();
        //   if (!this.$v.studentForm.$invalid && !this.$v.parentForm.$invalid) {
        //     this.modals.loading = true;
        //     this.modals.text = "Creando institución";
        //     this.begin();
        //   }

        //   break;
      }
    },
    inputBranch(event) {
      this.branchForm.address = event.address;
      this.branchForm.markLatitude = event.markLatitude;
      this.branchForm.markLongitude = event.markLongitude;
      this.branchForm.latitude = event.markLatitude;
      this.branchForm.longitude = event.markLongitude;
    },
    inputDoors(event) {
      this.doors = event;
    },
    inputTimezone(event) {
      this.branchForm.timezone = event;
    },
    inputZoom(event) {
      this.branchForm.zoom = event;
    },
    breakProcess(message) {
      this.modals.loading = false;
      this.modals.alert = true;
      this.modals.errorDescription = message;
    },
    async begin() {
      this.errors = [];
      if (!this.flags.step1) {
        this.branchForm.phone = this.userForm.phone;
        // this.responses["rBranch"] = 
        await this.createBranch();
        if (this.errors.length > 0)
          return this.breakProcess(
            "Ocurrió un error al crear la institución, verifica la información proporcionada. Si el problema persiste, favor de intentar más tarde"
          );
      }
      // if (!this.flags.step2) {
      //   this.responses["rLevel"] =  await this.createLevel();
      //   if (this.errors.length > 0)
      //     return this.breakProcess(
      //       "Ocurrió un error al crear el nivel, verifica la información proporcionada. Si el problema persiste, favor de intentar más tarde"
      //     );
      // }
      // if (!this.flags.step3) {
      //   this.responses["rGG"] = await this.createGroup();
      //   if (this.errors.length > 0)
      //     return this.breakProcess(
      //       "Ocurrió un error al crear el grupo, verifica la información proporcionada. Si el problema persiste, favor de intentar más tarde"
      //     );
      // }
      await this.createDoors()
      // if (!this.flags.step4) {
      //   this.responses["rDoors"] = await this.createDoors();
      //   if (this.errors.length > 0)
      //     return this.breakProcess(
      //       "Ocurrió un error al crear las puertas, verifica la información proporcionada. Si el problema persiste, favor de intentar más tarde"
      //     );
      // }
      // if (!this.flags.step5) {
      //   this.responses["rLinkDoors"] = await this.linkDoors();
      //   if (this.errors.length > 0)
      //     return this.breakProcess(
      //       "Ocurrió un error al añadir puertas al nivel, verifica la información proporcionada. Si el problema persiste, favor de intentar más tarde"
      //     );
      // }
      // if (!this.flags.step6) {
      //   this.responses["rCreateStudentParent"] = await this.createStdPrnt();
      //   if (this.errors.length > 0)
      //     return this.breakProcess(
      //       "Ocurrió un error al crear alumno con su tutor, puede que el correo esté repetido. Si el problema persiste, favor de intentar más tarde"
      //     );
      // }
      if (!this.flags.step5) {
        this.responses["rUserUpdate"] = await this.updateUser();
        if (this.errors.length > 0)
          return this.breakProcess(
            "Ocurrió un error al actualizar el usuario, verifica que el correo proporcionado sea el mismo con el que te registraste. Si el problema persiste, favor de intentar más tarde"
          );
      }
    },
    createBranch() {
      return this.$store
        .dispatch("branch/updateBranchOB", this.branchForm)
        .then(branchResponse => {
          this.flags.step1 = true;
          // return branchResponse;
        })
        .catch(error => {
          // this.errors.push(error);
          console.log(error);
          return null;
        });
    },
    createLevel() {
      this.modals.text = "Agregando nivel";
      var Level = {
        typeLevel: this.levelForm.typeLevel,
        abbr: this.levelForm.abbr,
        departureTime: this.levelForm.departureTime + ":00",
        branch: {
          // id: this.responses["rBranch"].data.entity.id
          id: this.getUser.branch.id
        }
      };
      
      return this.$store
        .dispatch("level/createLevel", Level)
        .then(levelResponse => {
          this.flags.step2 = true;
          return levelResponse;
        })
        .catch(error => {
          this.errors.push(error);
          console.log(error);
          return null;
        });
    },
    createGroup() {
      this.modals.text = "Agregando grupos";
      return this.$store
        .dispatch("gg/createGG", {
          id: this.responses["rLevel"].data.entity.id,
          // id: this.getUser.id,
          obj: { entity: [this.ggForm] }
        })
        .then(ggResponse => {
          this.flags.step3 = true;
          return ggResponse;
        })
        .catch(error => {
          this.errors.push(error);
          console.log(error);
          return null;
        });
    },
    createDoors() {
      this.modals.text = "Agregando puertas";
      var doors = {
        entity: this.doors
      };
      return this.$store
        .dispatch("doors/createDoorOB", doors)
        .then(doorResponse => {
          this.flags.step4 = true;
          return doorResponse;
        })
        .catch(error => {
          this.errors.push(error);
          console.log(error);
          return null;
        });
    },
    linkDoors() {
      var doorstoAdd = [];
      for (var d in this.levelForm.doors) {
        for (var dd in this.responses["rDoors"].data.entity) {
          if (
            this.responses["rDoors"].data.entity[dd].doorName ==
            this.levelForm.doors[d].doorName
          ) {
            doorstoAdd.push(this.responses["rDoors"].data.entity[dd]);
          }
        }
      }
      return this.$store
        .dispatch("doors/updateDoorsLevel", {
          data: { entity: doorstoAdd },
          id: this.responses["rLevel"].data.entity.id
        })
        .then(levelDoorsResponse => {
          this.flags.step5 = true;
          return levelDoorsResponse;
        })
        .catch(error => {
          this.errors.push(error);
          console.log(error);
          return null;
        });
    },
    createStdPrnt() {
      this.modals.text = "Creando alumno y tutor";
      var student = {
        firstName: this.studentForm.firstName,
        lastName: this.studentForm.lastName,
        gender: this.studentForm.gender,
        personId: this.studentForm.personId,
        gg: {
          id: this.responses["rGG"].data[0].entity.id
      

        },
        level: {
          id: this.responses["rLevel"].data.entity.id
     

        },
        parents: [
          {
            firstName: this.parentForm.firstName,
            lastName: this.parentForm.lastName,
            mail: this.parentForm.mail,
            passwd: "12345678a",
            branch: {
              // id: this.responses["rBranch"].data.entity.id
            id: this.getUser.branch.id
             

            },
            image: null
          }
        ],
        image: null
      };
      return this.$store
        .dispatch("student/createStudentPantent", student)
        .then(studentParentResponse => {
          this.flags.step6 = true;
          return studentParentResponse;
        })
        .catch(error => {
          this.errors.push(error);
          console.log(error);
          return null;
        });
    },
    updateUser() {
      this.modals.text = "Finalizando...";
      var updateUser = {
        id: this.$store.getters.getUser.id,
        firstName: this.userForm.firstName,
        lastName: this.userForm.lastName,
        mail: this.userForm.mail
      };
      return this.$store
        .dispatch("employee/updateProfile", updateUser)
        .then(userResponse => {
          this.flags.step5 = true;
          this.e1++;
          this.modals.loading = false;
        })
        .catch(error => {
          console.log(error);
          return null;
        });
    },
    logOut() {
      this.$emit("input", false);
      this.$emit("logOut");
    }
  },
  computed: {
    ...mapGetters(["getUser", "getBranchData"]),
    processErrorName() {
      const errors = [];
      if (!this.$v.userForm.firstName.$dirty) return errors;
      !this.$v.userForm.firstName.required &&
        errors.push("El nombre es requerido");
      return errors;
    },
    processErrorLastName() {
      const errors = [];
      if (!this.$v.userForm.lastName.$dirty) return errors;
      !this.$v.userForm.lastName.required &&
        errors.push("Apellidos requeridos");
      return errors;
    },
    processErrorEmail() {
      const errors = [];
      if (!this.$v.userForm.mail.$dirty) return errors;
      !this.$v.userForm.mail.required && errors.push("El correo es requerido");
      !this.$v.userForm.mail.email && errors.push("El correo no es valido");
      return errors;
    },
    processErrorPhone() {
      const errors = [];
      if (!this.$v.userForm.phone.$dirty) return errors;
      !this.$v.userForm.phone.required &&
        errors.push("El teléfono es requerido");
      return errors;
    },
    processBranchName() {
      const errors = [];
      if (!this.$v.branchForm.name.$dirty) return errors;
      !this.$v.branchForm.name.required &&
        errors.push("El nombre de la institución es requerido");
      return errors;
    },
    processLevelName() {
      const errors = [];
      if (!this.$v.levelForm.typeLevel.$dirty) return errors;
      !this.$v.levelForm.typeLevel.required &&
        errors.push("El nombre del nivel es requerido");
      return errors;
    },
    processLevelAbbr() {
      const errors = [];
      if (!this.$v.levelForm.abbr.$dirty) return errors;
      !this.$v.levelForm.abbr.required &&
        errors.push("La abreviación es requerida");
      return errors;
    },
    processGGrade() {
      const errors = [];
      if (!this.$v.ggForm.grade.$dirty) return errors;
      !this.$v.ggForm.grade.required &&
        errors.push("El nombre del grado es requerido");
      return errors;
    },
    processGGroup() {
      const errors = [];
      if (!this.$v.ggForm.group.$dirty) return errors;
      !this.$v.ggForm.group.required &&
        errors.push("El nombre del grupo es requerido");
      return errors;
    },
    processLevelDepartureTime() {
      const errors = [];
      if (!this.$v.levelForm.departureTime.$dirty) return errors;
      !this.$v.levelForm.departureTime.required &&
        errors.push("La hora de salida es requerida");
      return errors;
    },
    processLevelDoors() {
      const errors = [];
      if (!this.$v.levelForm.doors.$dirty) return errors;
      !this.$v.levelForm.doors.required &&
        errors.push("Las puertas del nivel son requeridas");
      !this.$v.levelForm.doors.minLength &&
        errors.push("Debe seleccionar al menos una puerta");
      return errors;
    },
    processStudentfirstName() {
      const errors = [];
      if (!this.$v.studentForm.firstName.$dirty) return errors;
      !this.$v.studentForm.firstName.required &&
        errors.push("Nombre requerido");
      return errors;
    },
    processStudentlastName() {
      const errors = [];
      if (!this.$v.studentForm.lastName.$dirty) return errors;
      !this.$v.studentForm.lastName.required &&
        errors.push("Apellidos requeridos");
      return errors;
    },
    processParentfirstName() {
      const errors = [];
      if (!this.$v.parentForm.firstName.$dirty) return errors;
      !this.$v.parentForm.firstName.required && errors.push("Nombre requerido");
      return errors;
    },
    processParentLastName() {
      const errors = [];
      if (!this.$v.parentForm.lastName.$dirty) return errors;
      !this.$v.parentForm.lastName.required &&
        errors.push("Apellidos requeridos");
      return errors;
    },
    processParentMail() {
      const errors = [];
      if (!this.$v.parentForm.mail.$dirty) return errors;
      !this.$v.parentForm.mail.required && errors.push("Correo requerido");
      !this.$v.parentForm.mail.email && errors.push("Correo requerido");
      return errors;
    },
    processStudentGender() {
      const errors = [];
      if (!this.$v.studentForm.gender.$dirty) return errors;
      !this.$v.studentForm.gender.required && errors.push("Género requerido");
      return errors;
    },
    processStudentPersonId() {
      const errors = [];
      if (!this.$v.studentForm.personId.$dirty) return errors;
      !this.$v.studentForm.personId.required &&
        errors.push("Matrícula requerida");
      return errors;
    }
  }
};
</script>

<style scoped>

#onB > .v-dialog {
  border-radius: 25px !important;
}
>>>.v-stepper__label{
  color: #BEC1C7 !important;
}
>>>.v-stepper__step__step{
  width: 50px !important;
  height: 50px !important;
  /* color:  #ef565c; */
  font-size: 17px !important;
  /* background: white !important; */

}
 >>>.v-stepper__step--active  .primary{
  color: #ef565c !important;
  background-color: white !important;
  border: 2px solid #ef565c;
}
>>>.v-stepper__step--active .v-stepper__label{
  color: #ef565c !important;

}
>>>.v-stepper__step--inactive .v-stepper__step__step{
  border: 2px solid #BEC1C7;
  color:  #BEC1C7 !important;
  font-size: 17px !important;
  background: white !important;
}
>>>.v-stepper__step--inactive .v-stepper__label{
  color: #BEC1C7 ;
}

>>>.v-stepper__step--complete .v-stepper__label{
    color: #111827 !important;
    font-weight: 500 !important;

}
.btn__iniciar {
  border-radius: 1rem;
  background: #ef565c !important;
  color: #fff;
}
.btn__next{
  border-radius: 1rem;
  background: white !important;
  color: #374151;
  border: 1px solid #D1D5DB !important;
}


>>>.v-input__slot{
  border-color: #D1D5DB !important;
  border-radius: 10px !important;

}
/deep/.v-text-field--box input, .v-text-field--full-width input, .v-text-field--outline input {
    margin-top: 0px !important;
}

>>>.v-text-field--outline .v-text-field__prefix {
    margin-top: 0px !important;
   
}
>>>.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
    padding-top: 0px !important;
}
>>>.v-text-field .v-input__append-inner, .v-text-field .v-input__prepend-inner {
  align-self: center !important;
}
>>>.v-text-field .v-input__append-inner, .v-text-field .v-input__prepend-inner {
  margin-top: 0px !important;
}
/* v-text-field--enclosed v-text-field--outline v-input--hide-details theme--light */

>>>.v-text-field--outline input {
    margin-top: 0px !important;
}
</style>
